"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stories = void 0;
// Bucket - svs-stories-storage-(dev-beta | prod)
/**
 * DIRECTORIES
 */
const STORIES_DIR = 'stories';
const BGS_DIR = 'backgrounds';
const TEMPLATES_DIR = 'templates';
const DEFAULT_STORIES_DIR = 'defaultstories';
const dirs = {
    BGS_DIR,
    STORIES_DIR,
    TEMPLATES_DIR,
    DEFAULT_STORIES_DIR,
};
/**
 * FILES
 */
// Provide a `key` if the path is constant
// /
const ALLOWED_LICENSORS_FILE = 'allowedLicensors.json';
// /defaultstories/backgrounds
const EXCLUSIVE_BGS_FILE = 'exclusiveBackgrounds.json';
// /templates/
const PROJECT_TEMPLATES_FILE = 'projectTemplates.json';
// /templates/{walletAddress}/
const TEMPLATES_FILE = 'templates.json';
// /stories/{walletAddress}/
const USER_FILE = 'user.json';
const files = {
    TEMPLATES_FILE,
    USER_FILE,
    EXCLUSIVE_BGS_FILE,
    PROJECT_TEMPLATES_FILE,
    ALLOWED_LICENSORS_FILE,
};
/**
 * KEYS - dir + file when path does not take variables
 */
const EXCLUSIVE_BGS_KEY = `${DEFAULT_STORIES_DIR}/${BGS_DIR}/${EXCLUSIVE_BGS_FILE}`;
const PROJECT_TEMPLATES_KEY = `${TEMPLATES_DIR}/${PROJECT_TEMPLATES_FILE}`;
const ALLOWED_LICENSORS_KEY = ALLOWED_LICENSORS_FILE;
const keys = {
    EXCLUSIVE_BGS_KEY,
    PROJECT_TEMPLATES_KEY,
    ALLOWED_LICENSORS_KEY,
};
exports.stories = {
    files,
    dirs,
    keys,
};
//# sourceMappingURL=index.js.map